import React from "react";
import { ActionIcon } from '@mantine/core';
import { IconPoint } from '@tabler/icons-react';

const ActionIconComponent = ({
    stateVariant = 'subtle',
    stateRadius = 'xl',
    stateTitle = '',
    stateSize = 'lg',
    stateDisabled = false,
    fnOnClick = () => null,

    StateIcon = IconPoint,
    stateIconSize = '1.125rem',
    stateIconStrokeWidth = 1.25,
    stateIconStyle = {},
    stateSXActionIcon = {},
}) => {
    return (
        <ActionIcon
            variant={stateVariant}
            radius={stateRadius}
            title={stateTitle}
            size={stateSize}
            disabled={stateDisabled}
            onClick={fnOnClick}

            sx={stateSXActionIcon}
        >
            <StateIcon
                size={stateIconSize}
                strokeWidth={stateIconStrokeWidth}
                style={stateIconStyle}
            />
        </ActionIcon>
    )
}

export default ActionIconComponent;